import { render } from "./SendRewards.vue?vue&type=template&id=5a23cc33"
import script from "./SendRewards.vue?vue&type=script&lang=js"
export * from "./SendRewards.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__